import type { PublisherHashmap } from '../types/publisher';
import { deviceType } from './enums';
import { cdnPublishersUrl, cdnPublishersHashmapUrl, loadJs, log, logError, loadJSON } from './utilities'


let _hashmap: PublisherHashmap | null = null;
let _hashmapQueue: string[] = [];

interface settings {
    url?: string;
}

const EVENTS = {
	PUBLISHER_LOADED: 'mega.publisher.loaded'
}

const cdnType: string = '' // s3 | fb | null

function getName() {
    return location.hostname.replace('www.','')
}

export async function load(settings: settings = {}) {
    return new Promise( (resolve) => {
        // get site specific js, but keep staging/demo urls intact
        const name = getName()
        const url = cdnPublishersUrl(cdnType) + '/' + name + '.js'

        addEventListener(EVENTS.PUBLISHER_LOADED, () => resolve(true))

        loadJs( settings.url ?? url, async () => dispatchEvent(new CustomEvent(EVENTS.PUBLISHER_LOADED)) )
        
    })
}

export async function loadHashmap(totalFiles: number|null = null) {
    // if(window._mega?.publisher?.debug) { // Delay hashmap loading for testing
    //     await new Promise(r => setTimeout(r, 1000));
    // }

    let version = 0;
    let fileNumber = '';
    if(totalFiles) {
        version = Math.floor(Math.random() * totalFiles + 1);
        fileNumber = '.' + version;
    }

    const name = getName()
    const url = cdnPublishersHashmapUrl(cdnType) + '/' + name + fileNumber + '.json'
    
    const hashmap = await loadJSON(url);
    if(!hashmap)
        return null;

    return {
        version: version,
        data: hashmap
    };
}
